import { LegalClientRepresentativeEntity } from 'api/types/entity';
import { isLegalRepresentativeCompany } from 'modules/client/common/helpers';

import { LegalRepresentativeRepresentativeType } from '../types';

export const getLegalRepresentativeRepresentativeType = (
  legalClientRepresentative: LegalClientRepresentativeEntity | null
): LegalRepresentativeRepresentativeType => {
  const isCompany = isLegalRepresentativeCompany(legalClientRepresentative);

  return isCompany ? 'company' : 'physical';
};
